export default __webpack_public_path__ + "static/media/ukgc.8ef30217.png";